import angular from 'angular';

import component from './eventInfo.component';

import '../../service';

let module = angular.module('recaps.components.eventInfo', [
  'recaps.services',
]);

module.component('eventInfo', component);

export default module;
